import { render, staticRenderFns } from "./u-divider-group.vue?vue&type=template&id=459921c7&scoped=true"
import script from "./u-divider-group.vue?vue&type=script&lang=js"
export * from "./u-divider-group.vue?vue&type=script&lang=js"
import style0 from "./u-divider-group.vue?vue&type=style&index=0&id=459921c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459921c7",
  null
  
)

export default component.exports